export function operacaoRecebimentosInRequest(params = {}) {
  return {
    type: '@operacaorecebimento/OPERACAORECEBIMENTOS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoRecebimento(idoperacaorecebimento) {
  return {
    type: '@operacaorecebimento/FIND_OPERACAORECEBIMENTO',
    payload: { idoperacaorecebimento },
  };
}

export function failedRequest() {
  return {
    type: '@operacaorecebimento/FAILED_REQUEST',
  };
}

export function deleteOperacaoRecebimento(idoperacaorecebimento, params) {
  return {
    type: '@operacaorecebimento/DELETE_OPERACAORECEBIMENTO',
    payload: { idoperacaorecebimento, params },
  };
}

export function updateOperacaoRecebimento(operacaorecebimentos, params) {
  return {
    type: '@operacaorecebimento/UPDATE_OPERACAORECEBIMENTO',
    payload: { operacaorecebimentos, params },
  };
}

export function storeOperacaoRecebimento(operacaorecebimento, params) {
  return {
    type: '@operacaorecebimento/STORE_OPERACAORECEBIMENTO',
    payload: { operacaorecebimento, params },
  };
}

export function successInRequest(
  operacaorecebimentos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaorecebimento/SUCCESS_IN_REQUEST',
    payload: { operacaorecebimentos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaorecebimento) {
  return {
    type: '@operacaorecebimento/SUCCESS_REQUEST',
    payload: { operacaorecebimento },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaorecebimento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaorecebimento/RECORD_FILTERING',
    payload: { params },
  };
}
